import { assert_not_null } from '@shared/asserts/utils_asserts';

export function FN_CANVAS__apply_image_compare__base(canvas: HTMLCanvasElement) {
  const ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');
  assert_not_null(ctx);

  // HiDPI adjustment
  const rect: DOMRect = canvas.getBoundingClientRect();
  const dpr: number = window.devicePixelRatio || 1;
  canvas.width = rect.width * dpr;
  canvas.height = rect.height * dpr;
  ctx.scale(dpr, dpr);

  ctx.clearRect(0, 0, rect.width, rect.height);

  ctx.fillStyle = '#171717';
  ctx.fillRect(0, 0, rect.width, rect.height);
}
